import { AUTHENTICATION } from "../authentication/authenticationConstants.js";
import { WATCHERS } from "../../actions/actionConstants.js";

export const INITIAL = {
  isReady: false
};

export const watchersReducer = (state = INITIAL, action = {}) => {
  switch (action.type) {
    case WATCHERS.READY:
      return {
        ...state,
        isReady: true
      };

    case WATCHERS.NOT_READY:
    case WATCHERS.RESET:
      return {
        ...state,
        isReady: false
      };

    case AUTHENTICATION.LOGOUT.DO:
    case AUTHENTICATION.LOGIN.FAILURE:
      return INITIAL;

    default:
      return state;
  }
};
